
/**
 * Utility functions for working with cookies
 */

/**
 * Get a cookie value by name
 * @param name The name of the cookie to retrieve
 * @returns The cookie value or empty string if not found
 */
export function getCookie(name: string): string {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift();
    return cookieValue || '';
  }
  
  return '';
}

/**
 * Set a cookie with the given name and value
 * @param name Cookie name
 * @param value Cookie value
 * @param days Number of days until the cookie expires
 */
export function setCookie(name: string, value: string, days = 30): void {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
}
